import "@fontsource/lato/latin-400.css";
import "@fontsource/lato/latin-700.css";
import "@fontsource/lato/latin-900.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-500.css";
import "@fontsource/manrope/latin-600.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "@fontsource/montserrat/latin-600.css";
import "@fontsource/montserrat/latin-700.css";
import "@fontsource/montserrat/latin-900.css";
import "./estilos/global.css";

import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App.js";
import { iniciarTelemetria } from "./telemetria.js";

iniciarTelemetria();

const raiz = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

/*
 * A landing da raiz e publicada como HTML independente e nao carrega esta
 * entrada. A calculadora e as paginas legais ainda podem hidratar o HTML
 * estatico; o aplicativo e montado em /painel e nas demais rotas privadas.
 */
let contaLembrada = false;
try { contaLembrada = Boolean(localStorage.getItem("ida.conta")); } catch { /* sem storage */ }
const paginaPublicaEstatica = [
  "/calculadora-imposto-aluguel", "/termos", "/privacidade",
].includes(window.location.pathname)
  || window.location.pathname === "/blog"
  || window.location.pathname.startsWith("/blog/");
const podeHidratarLanding = paginaPublicaEstatica
  && raiz.hasChildNodes()
  && !contaLembrada;

if (podeHidratarLanding) hydrateRoot(raiz, app);
else {
  raiz.replaceChildren();
  createRoot(raiz).render(app);
}
